interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
}: SectionHeadingProps) {
  return (
    <div className={align === "center" ? "max-w-2xl mx-auto text-center" : "max-w-3xl"}>
      {eyebrow && (
        <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-primary-600 mb-4">
          <span className="w-6 h-px bg-primary-400" />
          {eyebrow}
        </span>
      )}
      <h2 className="font-heading text-2xl md:text-4xl font-bold leading-tight text-foreground-950">
        {title}
      </h2>
      {description && (
        <p className="mt-4 text-base md:text-lg leading-relaxed text-foreground-600">
          {description}
        </p>
      )}
    </div>
  );
}